module.exports = __webpack_public_path__ + "img/zhibo_share_red.02895f2a.png";